<!-- <div class="not-prose notdownloadReportsdsr relative rounded-xl overflow-auto bg-blue-100 tableFixHead">
    <div class="flex flex-row flex-wrap  pl-2 pr-2 pt-2 pb-2 flex items-center" id="dsrreportdata">

        <mat-form-field class="pr-2 w-[140px] " appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">RO Name</mat-label>
            <input matInput class="text-blue-800 p-1 h-8 text-sm" [disabled]="true" [(ngModel)]="roname" id="title" name="title">
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px] " appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">RO Code</mat-label>
            <input matInput class="text-blue-800 p-1 h-8 text-sm" [disabled]="true" [(ngModel)]="rocode" id="title" name="title">
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px] " appearance="fill" >
            <mat-label class="text-blue-800 mb-1 block">Month and Year</mat-label>
            <input class="text-blue-800 p-1 h-8 text-sm" matInput [matDatepicker]="dp" [formControl]="date">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
                (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px]" appearance="fill" >
            <mat-label class="text-blue-800 mb-1 block">Product Code</mat-label>
            <mat-select class="text-blue-800 p-1 h-8 text-sm tankid" 
                name="product" id="product" [(ngModel)]="product_code" placeholder="Product code">
                <mat-option [value]="tank.product_code" *ngFor="let tank of product;">
                    {{ producthash[tank.product_code] ? producthash[tank.product_code].product_name : tank.product_code }}
                </mat-option>
            </mat-select>
            <mat-error>
                Please enter the product code
            </mat-error>
        </mat-form-field>
        <button id="gbtnactiondefoir" class="pr-4" *ngIf="!hidego" (click)="fetchRecord()" matTooltip="Search Data" mat-raised-button >
            GO
        </button>
    </div>

    <div class="">
        <div style="background-position:10px 10px"
            class="inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))] dark:bg-grid-slate-700/25 dark:[mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.5))]">
        </div>
        <div class="relative rounded-xl">
            <div class="shadow-sm scrollclass overflow-x-auto mx-6 mb-6 mt-4 dsrreportdatain" id="dsrreportdatain"
                *ngIf="monthData && monthData.tanks && monthData.nozzles" style="max-height: 70vh !important;">
                <table class="border-collapse table-auto w-full text-md dsrreportdatainx" id="dsrreportdatainx">
                    <col class="z-0 p-2">
                    <colgroup class="z-[1] p-2" [attr.span]="monthData.tanks.length"></colgroup>
                    <col class="z-[3] p-2">
                    <colgroup class="z-[4] p-2" [attr.span]="monthData.nozzles.length"></colgroup>
                    <col class="z-[7] p-2">
                    <col class="z-[9] p-2">
                    <col class="z-[10] p-2">
                    <col class="z-[13] p-2">
                    <col class="z-[14] p-2">
                    <tr>
                        <th class="z-0 border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-4 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2">Day</th>
                        <ng-container *ngFor="let tan of monthData.tanks;">
                            <th class="z-[1] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-4 pt-1 pb-3 text-blue-600 text-center"
                                colspan="2" scope="colgroup">Tank: {{tan.tank}}</th>
                        </ng-container>
                        <th class="z-[3] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Tank Dip Sales (Ltr)</th>
                        <th class="z-[4] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            [attr.colspan]="monthData.nozzles.length" scope="colgroup">Global Nozzle Nos (Opening
                            Totalizer)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                        rowspan="2" scope="col">Net Totalizer Sale For The Day (Ltr)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                        rowspan="2" scope="col">Cumulative Totalizer Sale For The Month(Ltr)</th>
                        <th class="z-[9] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Net Transaction Sale For The Day (Ltr)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                        rowspan="2" scope="col">Cumulative Transaction Sale For The Month(Ltr)</th>
                        <th class="z-[10] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">(D-F) Ltr</th>
                        <th class="z-[13] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Loss/Gain as per Totalizer (Ltr)</th>
                        <th class="z-[14] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Loss/Gain as per Transaction (Ltr)</th>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let tan of monthData.tanks;">
                            <th class="z-[1] subtab border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                                scope="col">Opening Stock (Ltr)</th>
                            <th class="z-[1] subtab border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                                scope="col">Received (Ltr)</th>
                        </ng-container>
                        <ng-container *ngFor="let noz of monthData.nozzles;">
                            <th class="z-[4] subtab border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                                scope="col">{{noz.nozzle_id}}</th>
                        </ng-container>
                    </tr>

                    <ng-container *ngFor="let rec of data">
                        <tr class="bg-white " id="isscrolled">
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.day}}</td>
                            <ng-container *ngFor="let tan of rec.tanks">
                                <td
                                    class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                    {{tan.start_product_volume | number: '1.0-2'}}
                                </td>
                                <td
                                    class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                    {{tan.decant_volume | number: '1.0-2'}}
                                </td>
                            </ng-container>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.total_tank_sales | number: '1.0-2'}}</td>
                            <ng-container *ngFor="let noz of rec.nozzles">
                                <td
                                    class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                    {{noz.start_totalizer_volume | number: '1.0-2'}}
                                </td>
                            </ng-container>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_totalizer | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_totalizer_month | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_sales | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_sales_month | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.d_minus_f | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.gain_per_totalizer | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.gain_per_transaction | number: '1.0-2'}}
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </div>
    </div>
</div> -->

<div class="not-prose notdownloadReportsdsr relative rounded-xl overflow-auto bg-blue-100 tableFixHead">
    <div class="flex flex-row flex-wrap  pl-2 pr-2 pt-2 pb-2 flex items-center" id="dsrreportdata">

        <mat-form-field class="pr-2 w-[140px] " appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">RO Name</mat-label>
            <input matInput class="text-blue-800 p-1 h-8 text-sm" [disabled]="true" [(ngModel)]="roname" id="title"
                name="title">
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px] " appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">RO Code</mat-label>
            <input matInput class="text-blue-800 p-1 h-8 text-sm" [disabled]="true" [(ngModel)]="rocode" id="title"
                name="title">
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px] " appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">Month and Year</mat-label>
            <input class="text-blue-800 p-1 h-8 text-sm" matInput [matDatepicker]="dp" [formControl]="date">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
                (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field class="pr-2 w-[140px]" appearance="fill">
            <mat-label class="text-blue-800 mb-1 block">Product Code</mat-label>
            <mat-select class="text-blue-800 p-1 h-8 text-sm tankid" name="product" id="product"
                [(ngModel)]="product_code" (selectionChange)="fetchRecord()" placeholder="Product code">
                <mat-option [value]="tank.product_code" *ngFor="let tank of product;">
                    {{ producthash[tank.product_code] ? producthash[tank.product_code].product_name : tank.product_code
                    }}
                </mat-option>
            </mat-select>
            <mat-error>
                Please enter the product code
            </mat-error>
        </mat-form-field>
        <button id="gbtnactiondefoir" class="pr-4" *ngIf="!hidego" (click)="fetchRecord()" matTooltip="Search Data"
            mat-raised-button>
            GO
        </button>
    </div>

    <div class="">
        <div style="background-position:10px 10px"
            class="inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))] dark:bg-grid-slate-700/25 dark:[mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.5))]">
        </div>
        <div class="relative rounded-xl">
            <div class="shadow-sm scrollclass overflow-x-auto mx-6 mb-6 mt-4 dsrreportdatain" id="dsrreportdatain"
                *ngIf="monthData && monthData.tanks && monthData.nozzles" style="max-height: 70vh !important;">
                <table class="border-collapse table-auto w-full text-md dsrreportdatainx" id="dsrreportdatainx">
                    <col class="z-0 p-2">
                    <colgroup class="z-[1] p-2" [attr.span]="monthData.tanks.length"></colgroup>
                    <col class="z-[3] p-2">
                    <colgroup class="z-[4] p-2" [attr.span]="monthData.nozzles.length"></colgroup>
                    <col class="z-[7] p-2">
                    <col class="z-[9] p-2">
                    <col class="z-[10] p-2">
                    <col class="z-[13] p-2">
                    <col class="z-[14] p-2">
                    <tr>
                        <th class="z-0 border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-4 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2">Day</th>
                        <ng-container *ngFor="let tan of monthData.tanks;">
                            <th class="z-[1] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-4 pt-1 pb-3 text-blue-600 text-center"
                                colspan="1" scope="colgroup">Tank: {{tan.tank}}</th>
                        </ng-container>
                        <th class="z-[3] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Volume Decanted (Ltr) </th>
                        <th class="z-[3] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Tank Dip Sales (Ltr)</th>
                        <th class="z-[4] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            [attr.colspan]="monthData.nozzles.length" scope="colgroup">Global Nozzle Nos (Opening
                            Totalizer)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Net Totalizer Sale For The Day (Ltr)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Cumulative Totalizer Sale For The Month(Ltr)</th>
                        <th class="z-[9] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Net Transaction Sale For The Day (Ltr)</th>
                        <th class="z-[7] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Cumulative Transaction Sale For The Month(Ltr)</th>
                        <th class="z-[10] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">(D-F) Ltr</th>
                        <th class="z-[13] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Loss/Gain as per Totalizer (Ltr)</th>
                        <th class="z-[14] border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                            rowspan="2" scope="col">Loss/Gain as per Transaction (Ltr)</th>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let tan of monthData.tanks;">
                            <th class="z-[1] subtab border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                                scope="col">Opening Stock (Ltr)</th>
                        </ng-container>
                        <ng-container *ngFor="let noz of monthData.nozzles;">
                            <th class="z-[4] subtab border-b border-l border-r border-blue-100 bg-blue-200 font-medium p-4 pl-6 pr-6 pt-1 pb-3 text-blue-600 text-center"
                                scope="col">{{noz.nozzle_id}}</th>
                        </ng-container>
                    </tr>

                    <ng-container *ngFor="let rec of data">
                        <tr class="bg-white " id="isscrolled">
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.day}}</td>
                            <ng-container *ngFor="let tan of rec.tanks">
                                <td
                                    class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                    {{tan.start_product_volume | number: '1.0-2'}}
                                </td>
                            </ng-container>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.volume_decanted | number: '1.0-2'}}</td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.total_tank_sales | number: '1.0-2'}}</td>
                            <ng-container *ngFor="let noz of rec.nozzles">
                                <td
                                    class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                    {{noz.start_totalizer_volume | number: '1.0-2'}}
                                </td>
                            </ng-container>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_totalizer | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_totalizer_month | number: '1.0-2'}}
                            </td>

                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_sales | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.cumulative_sales_month | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.d_minus_f | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.gain_per_totalizer | number: '1.0-2'}}
                            </td>
                            <td class="border-b border-blue-100 text-center dark:border-blue-100 p-2 text-blue-800 ">
                                {{rec.gain_per_transaction | number: '1.0-2'}}
                            </td>
                        </tr>
                    </ng-container>

                    <tr *ngIf="data && data.length" class="bg-blue-50 font-medium">
                        <td class="border-b border-blue-100 text-left dark:border-blue-100 p-2 text-blue-800 whitespace-nowrap min-w-[260px]">
                            Total Decanted Volume (Month)
                        </td>
                        <td class="border-b border-blue-100 text-left dark:border-blue-100 p-2 text-blue-800 ">
                            {{totalDecantedMonth | number: '1.0-2'}}
                        </td>
                        <td class="border-b border-blue-100 dark:border-blue-100 p-2"
                            [attr.colspan]="tableColumnCount - 2"></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>